import { MinisiteConfiguration } from '@3ddv/ngx-sites-builder-lib';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { CopylinkComponent } from '../../sb-editor-tools/copylink/copylink.component';
import { Copylink } from '../../sb-editor-tools/copylink/models/copylink.model';
import { FullscreenComponent } from '../../sb-editor-tools/fullscreen/fullscreen.component';
import { Fullscreen } from '../../sb-editor-tools/fullscreen/models/fullscreen.model';
import { IndoorComponent } from '../../sb-editor-tools/indoor/indoor.component';
import { Indoor } from '../../sb-editor-tools/indoor/models/indoor.model';
import { Navigation } from '../../sb-editor-tools/navigation/models/navigation.model';
import { NavigationComponent } from '../../sb-editor-tools/navigation/navigation.component';
import { ToolsService } from '../../sb-editor-tools/services/tools.service';
import { Vr } from '../../sb-editor-tools/vr/models/vr.model';
import { VrComponent } from '../../sb-editor-tools/vr/vr.component';
import { SblibService } from '../../services/sblib.service';
import { VersionService } from '../services/version.service';
import { VersionComponent } from './version/version.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-plugins',
  templateUrl: './plugins.component.html',
  styleUrls: ['./plugins.component.scss'],
})
export class PluginsComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription>;
  private toolgroup: {
    copylink: Copylink;
    fullscreen: Fullscreen;
    indoor: Indoor;
    vr: Vr;
    navigation: Navigation;
  };
  public tabs = {
    active: 'plugins',
  };
  public minisiteConfiguration: MinisiteConfiguration;
  public workflow: any;

  fsTool;
  cpTool;
  vrTool;
  indoorTool;
  navTool;

  @ViewChild('fullscreen', { static: false }) fullscreenComponent: FullscreenComponent;
  @ViewChild('copylink', { static: false }) copylinkComponent: CopylinkComponent;
  @ViewChild('vr', { static: false }) vrComponent: VrComponent;
  @ViewChild('indoor', { static: false }) indoorComponent: IndoorComponent;
  @ViewChild('navigation', { static: false }) navigationComponent: NavigationComponent;
  @ViewChild('version', { static: false }) viewer3dversionComponent: VersionComponent;

  constructor(
    private toolsService: ToolsService,
    private sblibService: SblibService,
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private versionService: VersionService
  ) {
    this.workflow = this.activatedRoute.snapshot.data.dataFlow.workflow;
    // create site
    this.minisiteConfiguration = {
      mapConfig: {
        map_id: this.workflow.map_id,
        venue_id: this.workflow.venue_id,
        workflow_id: this.workflow.id,
        enabled: true,
        client: '',
        set_id: this.workflow.set_id,
      },
      toolsConfig: {},
    };
    // edit site
    if (this.activatedRoute.snapshot.data.site && this.activatedRoute.snapshot.data.site.master) {
      this.minisiteConfiguration.mapConfig = this.activatedRoute.snapshot.data.site.master.mapConfig;
    }
  }

  ngOnInit(): void {
    this.subscriptions = [];
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      console.log(res);
      this.toolgroup = {
        copylink: null,
        fullscreen: null,
        indoor: null,
        vr: null,
        navigation: null,
      };
      if (res.fullscreen) {
        this.fsTool = true;
        this.toolgroup.fullscreen = JSON.parse(JSON.stringify(res.fullscreen));
      } else {
        this.fsTool = false;
      }

      if (res.copylink) {
        this.cpTool = true;
        this.toolgroup.copylink = JSON.parse(JSON.stringify(res.copylink));
      } else {
        this.cpTool = false;
      }

      if (res.vr) {
        this.vrTool = true;
        this.toolgroup.vr = JSON.parse(JSON.stringify(res.vr));
      } else {
        this.vrTool = false;
      }

      if (res.indoor) {
        this.indoorTool = true;
        this.toolgroup.indoor = JSON.parse(JSON.stringify(res.indoor));
      } else {
        this.indoorTool = false;
      }

      if (res.navigation) {
        this.navTool = true;
        this.toolgroup.navigation = JSON.parse(JSON.stringify(res.navigation));
      } else {
        this.navTool = false;
      }
    });
    this.subscriptions.push(tools$);
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }
  public save() {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (this.tabs.active === 'viewer') {
        res.copylink = JSON.parse(JSON.stringify(this.toolgroup.copylink));
        res.fullscreen = JSON.parse(JSON.stringify(this.toolgroup.fullscreen));
        res.vr = JSON.parse(JSON.stringify(this.toolgroup.vr));
      }

      if (this.tabs.active === 'plugins') {
        res.indoor = JSON.parse(JSON.stringify(this.toolgroup.indoor));
        res.navigation = JSON.parse(JSON.stringify(this.toolgroup.navigation));
      }

      if (this.tabs.active === 'tecnic') {
        this.minisiteConfiguration.mapConfig.set_id = this.viewer3dversionComponent.panosversion;
        this.versionService.setPanoVersion(this.minisiteConfiguration.mapConfig.set_id);
      }

      this.sblibService.apply(res, this.minisiteConfiguration.mapConfig);
      console.log(this.minisiteConfiguration);
      console.log(res);
      this.toastrService.success('', 'Changes applied');
    });
    this.subscriptions.push(tools$);
  }

  public getTool(tool: Fullscreen | Copylink | Indoor | Vr | Navigation, toolkey: string) {
    this.toolgroup[toolkey] = JSON.parse(JSON.stringify(tool));
  }
}
